<form [formGroup]="phoneNumberForm" *ngrxLet="{ hasErrors: hasErrors$, id: id$ } as vm" [class.disabled]="phoneNumberForm.disabled">
    <label class="phone-number-label" [for]="vm.id">{{ "dtmUi.phoneNumberField.phoneNumberLabel" | transloco }}</label>
    <div class="phone-number-fields-container" #formContainer [attr.aria-labelledby]="vm.id">
        <dtm-ui-select-field
            maxPanelHeight="320px"
            [isClearable]="false"
            [formControl]="countryFormControl"
            [class.error]="vm.hasErrors"
            [panelWidth]="(dropdownWidth$ | ngrxPush) + 'px'"
            (keydown)="phoneSelectKeyDown($event)"
            (openedChange)="$event ? search?.focus() : searchControl.reset('')"
            #select
        >
            <mat-select-trigger *ngrxLet="selectedCountry$ as selectedCountry">
                <dtm-ui-country-flag-display [country]="selectedCountry?.alpha3Code"></dtm-ui-country-flag-display>
                <span>+{{ selectedCountry?.countryNumber }}</span>
            </mat-select-trigger>
            <dtm-ui-input-field class="search">
                <input
                    #search
                    matInput
                    [formControl]="searchControl"
                    [placeholder]="'dtmUi.phoneNumberField.search' | transloco"
                    (keydown.space)="$event.stopPropagation()"
                    (keydown.enter)="assignSelectedCountryCode()"
                />
            </dtm-ui-input-field>
            <p class="empty-list" *ngIf="!listOfCountriesDisplay.length">{{ "dtmUi.phoneNumberField.emptyListInfo" | transloco }}</p>
            <dtm-ui-select-option
                [value]="country.alpha2Code"
                *ngFor="let country of listOfCountriesDisplay; let i = index; trackBy: countryListItemTrack"
                isCustomContent
            >
                <span class="option">
                    <dtm-ui-country-flag-display [country]="country.alpha3Code"></dtm-ui-country-flag-display>
                    <span>{{ country.displayName }}</span>
                </span>
            </dtm-ui-select-option>
            <ng-content select=".country-code-hint" ngProjectAs=".field-hint"></ng-content>
            <ng-content select=".invalid-country-code" ngProjectAs=".field-error"></ng-content>
        </dtm-ui-select-field>
        <dtm-ui-input-field>
            <input matInput [formControl]="phoneNumberControl" (blur)="propagateTouch()" inputmode="numeric" [id]="vm.id" />
            <ng-content select=".phone-number-hint" ngProjectAs=".field-hint"></ng-content>
            <ng-content select=".field-error" ngProjectAs=".field-error"></ng-content>
        </dtm-ui-input-field>
    </div>
</form>
